import React, { useEffect,  useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import FASParentChild from "../../../../../components/Tables/FASParentChild";
import { MainFilter } from "../../../../../Redux/Slice/login/loginSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";
import {
  ClosingFas,
  TrialClosing,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Trial Balance/TrialBalanceSlice";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Closing({ accountGroup, Fromdate, ToDate }) {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { TrialClosingdata } = useSelector((state) => state.TrialBalanceSlice);

  const [groupLevels, setGroupLevels] = useState([]);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;

  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(ClosingFas());
    dispatch(
      TrialClosing({
        Firm,
        Year: FinancialYear,
        selectedIds: accountGroup.join(","),
        Fromdate,
        ToDate,
      }),
    );
  }, [dispatch, Firm, FinancialYear, accountGroup, Fromdate, ToDate]);

  const formatAmount = (value) => {
    if (!value || value === "(Multiple)") return 0;
    const num = Number(value.toString().replace(/,/g, ""));
    return isNaN(num) ? 0 : num;
  };

  const getRows = TrialClosingdata?.Detail?.map((item, index) => ({
    srNumber: index + 1,
    GroupMstName: item.GroupMstName,
    ParentGroupName: item.ParentGroupName,
    AcLaieName: item.AcLaieName,
    AcName: item.AcName,
    NetBalCrAmt: item.NetBalCrAmt,
    NetBalDrAmt: item.NetBalDrAmt,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", lign: "center" },
    { label: "Ac Type", key: "AcLaieName", lign: "left" },
    { label: "AcGroup Name", key: "GroupMstName", align: "left" },
    { label: "ParentGroup Name", key: "ParentGroupName", align: "left" },
    { label: "Ac Name", key: "AcName", align: "left" },
    {
      label: "NetBalance DrAmt",
      key: "NetBalDrAmt",
      align: "right",
      format: true,
    },
    {
      label: "NetBalance CrAmt",
      key: "NetBalCrAmt",
      align: "right",
      format: true,
    },
  ];

  if (TrialClosingdata === "no" || TrialClosingdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= COLOR CONVERTER ================= */
    const getJsPdfColor = (color) => {
      if (!color) return [0, 0, 0];

      if (Array.isArray(color)) return color;

      if (color.startsWith("#")) {
        let hex = color.replace("#", "");

        if (hex.length === 3) {
          hex = hex
            .split("")
            .map((x) => x + x)
            .join("");
        }

        const bigint = parseInt(hex, 16);

        return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
      }

      if (color.startsWith("rgb")) {
        return color.match(/\d+/g).map(Number);
      }

      return [0, 0, 0];
    };

    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");

    const title = "Trial Balance Closing";

    doc.text(title, pageWidth / 2, 15, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    /* ================= FIRM NAME ================= */
    const firmName = DataMain?.Firm_List?.[0]?.GroupName || "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    doc.text(firmName, pageWidth / 2, 25, {
      align: "center",
    });

    /* ================= TABLE START POSITION ================= */
    let startY = 33;
    /* ================= DATA ================= */
    const allRows = TrialClosingdata?.Detail || [];

    const liabilities = allRows.filter((r) =>
      (r.AcLaieName || "").toLowerCase().includes("liabil"),
    );

    const assets = allRows.filter((r) =>
      (r.AcLaieName || "").toLowerCase().includes("asset"),
    );

    const orderedRows = [...liabilities, ...assets];

    /* ================= TOTAL ================= */
    const summary = TrialClosingdata?.Summary?.[0] || {};

    const totals = {
      NetDr: Number(summary.NetBalDrAmt || 0),
      NetCr: Number(summary.NetBalCrAmt || 0),
    };

    /* ================= FORMAT FUNCTION ================= */
    const formatAmount = (val) => {
      const num = Number(val || 0);

      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };
    /* ================= BODY ================= */
    let sr = 1;

    const bodyRows = getRows.map((row) => [
      row.srNumber,
      row.AcLaieName,
      row.GroupMstName,
      row.AcName,
      formatAmount(row.NetBalDrAmt),
      formatAmount(row.NetBalCrAmt),
    ]);

    /* ================= TOTAL ROW ================= */
    bodyRows.push([
      "",
      "",
      "",
      "TOTAL",
      formatAmount(totals.NetDr),
      formatAmount(totals.NetCr),
    ]);

    /* ================= TABLE ================= */
    autoTable(doc, {
      startY,

      head: [["Sr", "Ac Type", "Ac Group", "Account Name", "Net Dr", "Net Cr"]],
      body: bodyRows,

      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 2,
        valign: "middle",
        textColor: [0, 0, 0],
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        fontSize: 9,
      },

      bodyStyles: {
        fontStyle: "bold",
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 15, fontStyle: "bold" },
        1: { cellWidth: 40, fontStyle: "bold" },
        2: { cellWidth: 45, fontStyle: "bold" },
        3: { cellWidth: 70, fontStyle: "bold" },
        4: { halign: "right", fontStyle: "bold" },
        5: { halign: "right", fontStyle: "bold" },
      },

      /* ================= TOTAL ROW STYLE ================= */
      didParseCell(data) {
        if (data.row.raw[3] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [240, 240, 240];
        }
      },

      /* ================= FOOTER ================= */
      didDrawPage() {
        const pageNo = doc.internal.getCurrentPageInfo().pageNumber;

        doc.setFontSize(8);
        doc.setTextColor(100);

        doc.text(
          `Generated on: ${new Date().toLocaleDateString()}`,
          marginX,
          pageHeight - 5,
        );

        doc.text(`Page ${pageNo}`, pageWidth - marginX, pageHeight - 5, {
          align: "right",
        });
      },
    });

    /* ================= SAVE ================= */
    doc.save("Closing_Balance_Statement.pdf");
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <button
          onClick={handleDownload}
          className="common-hover-btn"
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
            color:
              isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour12,
            border: "none",
            padding: "10px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            height: "44px",
          }}
        >
          <Download size={16} />
          Download PDF
        </button>
      </div>

      <div style={{ marginTop: "20px" }}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              padding: "14px",
              margin: 0,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              CLOSING
            </h2>
          </div>

          <FASparentMultipalChild
            columns={getColumns}
            data={getRows}
            externalTotals={TrialClosingdata?.Summary?.[0] || {}}
          />
        </div>
      </div>
    </>
  );
}
